import React from "react"
import "./newEcoSystem.scss"
import stateGuardianNetwork from "../../images/home/stateGuardianNetwork.png"
import celerBridge from "../../images/home/celerBridge.png"
import layer2Finance from "../../images/home/layer2Finance.png"
import { homeLinks } from "../../constants"

const ecosystemList = [
  {
    imageInfo: {
      imgSrc: stateGuardianNetwork,
      imgBgColor: "#EEEEEE",
    },
    descInfo: {
      title: "Stake $CELR, help secure Celer and capture network value.",
      subTitle: "",
      bgColor: "#E9BCFF",
      desc:
        "The Celer State Guardian Network (SGN) is a Proof-of-Stake (PoS) blockchain built on Tendermint that serves as the message router between different blockchains. Validator nodes have to stake CELR tokens to join the consensus process of the SGN.  The CELR staking process is crucial part of the economic security of the Celer Inter-chain Message Framework. To use the SGN’s message routing service and to store the multi-signature attestation, users must pay a fee to the SGN for these services. These usage fees are distributed to the CELR stakers and validators for their work in securing the network in addition to the block reward.",
      linkList: [
        {
          text: "Stake CELR",
          link: homeLinks.useCeler.stateGuardianNetwork.stakeCELR,
        },
        {
          text: "Run a validator",
          link: homeLinks.useCeler.stateGuardianNetwork.runAValidator,
        },
        {
          text: "Learn more",
          link: "/technology",
        },
      ],
      useAppInfoList: [],
    },
  },
  {
    imageInfo: {
      imgSrc: celerBridge,
      imgBgColor: "#EEEEEE",
    },
    descInfo: {
      title: "Multi-blockchain asset bridge, instant transfer, zero trust",
      subTitle: "",
      bgColor: "#58C971",
      desc:
        "Celer cBridge is a decentralized and non-custodial asset bridge that supports 110+ tokens across 30+ blockchains and layer-2 rollups. Built on top of the Celer Inter-chain Message Framework, cBridge has processed ~$8B cross-chain asset transfer volume on 30+ blockchains for more than 160K unique users, and is quickly growing and expanding into more blockchains and layer-2s.",
      link: "https://cbridge.celer.network/",
      linkList: [
        {
          text: "Learn more",
          link: homeLinks.useCeler.celerBridge.learnMore,
        },
        {
          text: "List Token",
          link: homeLinks.useCeler.celerBridge.listToken,
        },
      ],
      useAppInfoList: [
        {
          useAppLink: homeLinks.useCeler.celerBridge.useApp,
          text: "Use APP",
        },
      ],
    },
  },
  {
    imageInfo: {
      imgSrc: layer2Finance,
      imgBgColor: "#EEEEEE",
    },
    descInfo: {
      title: "Easy access, 100X lower cost for DeFi",
      subTitle: "",
      bgColor: "#2C98F3",
      desc:
        "Layer2.finance tackles the two largest challenges preventing DeFi from reaching mass adoption: the extraordinarily high transaction fees and being very difficult to navigate and use. Layer2.finance is a novel solution that allows people to access all existing DeFi protocols at a fraction of the cost by acting like a “DeFi Public Transportation System”.",
      link: "https://github.com/celer-network/celer-light-client",
      linkList: [
        {
          text: "Learn more",
          link: homeLinks.useCeler.layer2finance.learnMore,
        },
      ],
      useAppInfoList: [
        {
          useAppLink: homeLinks.useCeler.layer2finance.useApp,
          text: "Use App",
        },
      ],
    },
  },
]

export default function Ecosystem() {
  return (
    <div className="eco-system">
      <div className="eco-system-title">Use Celer</div>
      <div className="eco-system-contents">
        {ecosystemList.map((item, index) => {
          return (
            <div className="eco-system-content" key={index}>
              <div
                className={`eco-system-content-img ${
                  index % 2 === 0 ? "order-sm-1" : "order-sm-2"
                }`}
              >
                <div className="eco-system-content-img-content">
                  <img src={item.imageInfo.imgSrc} alt="" />
                </div>
              </div>
              <div
                className={`eco-system-content-text-bg ${
                  index % 2 === 0 ? "order-sm-2" : "order-sm-1"
                }`}
                style={{ background: item.descInfo.bgColor }}
              >
                <div className={`eco-system-content-text`}>
                  <div className="eco-system-content-text-title">
                    {item.descInfo.title}
                  </div>
                  <div className="eco-system-content-text-content">
                    {item.descInfo.desc}
                  </div>
                  <div className="eco-system-content-text-links">
                    <div className="eco-system-text-links">
                      {item.descInfo.linkList?.map(linkItem => {
                        return (
                          <div className="eco-system-text-links-item">
                            <a
                              href={linkItem.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {linkItem.text}
                            </a>
                          </div>
                        )
                      })}
                    </div>
                    <div className="eco-system-btn-links">
                      {item.descInfo.useAppInfoList.map(useAppInfo => {
                        return (
                          <div className="eco-system-btn-links-item">
                            <a
                              href={useAppInfo.useAppLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {useAppInfo.text}
                            </a>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
